import 'keen-slider/keen-slider.min.css';

import { Carousel } from '@lyearn/molecules';

export default Carousel;
